import{gql as e}from"@apollo/client";const r=e`
  query getUserFlowStepByUrl($userFlowId: Int!, $userFlowStepUrl: String!) {
    userFlowStep {
      getUserFlowStepByName(userFlowId: $userFlowId, userFlowStepUrl: $userFlowStepUrl) {
        id
        userRepetition {
          completed
          id
        }
      }
    }
  }
`;export{r as GET_USER_FLOW_STEP_BY_URL_QUERY};
//# sourceMappingURL=useGetUserFlowStep.graphql.js.map
